(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funds-support-new"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.funds-support-new').forEach(function (section) {

    const modal = section.querySelector('.funds-video-modal');
    const modalContent = section.querySelector('.funds-video-modal-content');
    const closeButton = section.querySelector('.funds-video-modal-close');

    if (!modal || !modalContent) return;


    /*
     * -----------------------------------------
     * GET YOUTUBE EMBED URL
     * -----------------------------------------
     */
    function getYouTubeEmbed(url) {

      try {

        const parsedUrl = new URL(url);

        let videoId = '';

        // youtu.be/VIDEO_ID
        if (parsedUrl.hostname.includes('youtu.be')) {

          videoId = parsedUrl.pathname
            .split('/')
            .filter(Boolean)[0] || '';

        }

        // youtube.com/watch?v=VIDEO_ID
        if (parsedUrl.hostname.includes('youtube.com')) {

          videoId = parsedUrl.searchParams.get('v') || '';

          // youtube.com/embed/VIDEO_ID
          if (!videoId && parsedUrl.pathname.includes('/embed/')) {

            videoId = parsedUrl.pathname
              .split('/embed/')[1]
              .split('/')[0];

          }

          // youtube.com/shorts/VIDEO_ID
          if (!videoId && parsedUrl.pathname.includes('/shorts/')) {

            videoId = parsedUrl.pathname
              .split('/shorts/')[1]
              .split('/')[0];

          }

        }

        if (!videoId) {
          return null;
        }

        return (
          'https://www.youtube.com/embed/' +
          videoId +
          '?autoplay=1&rel=0'
        );

      } catch (error) {

        console.error('YouTube URL error:', error);

        return null;

      }

    }


    /*
     * -----------------------------------------
     * GET VIMEO EMBED URL
     * -----------------------------------------
     *
     * Supports:
     *
     * https://vimeo.com/123456789
     *
     * https://vimeo.com/123456789/abcdef1234
     *
     * https://player.vimeo.com/video/123456789
     *
     * https://player.vimeo.com/video/123456789?h=abcdef1234
     *
     */
    function getVimeoEmbed(url) {

      try {

        const parsedUrl = new URL(url);

        let videoId = '';
        let privacyHash = '';


        /*
         * Get all URL path segments
         */
        const pathParts = parsedUrl.pathname
          .split('/')
          .filter(Boolean);


        /*
         * Find numeric Vimeo video ID
         */
        videoId = pathParts.find(function (part) {

          return /^\d+$/.test(part);

        }) || '';


        /*
         * Check for Vimeo privacy hash
         *
         * Example:
         *
         * ?h=abcdef1234
         */
        privacyHash =
          parsedUrl.searchParams.get('h') || '';


        /*
         * Some Vimeo URLs use the privacy hash
         * directly after the video ID:
         *
         * /123456789/abcdef1234
         */
        if (!privacyHash && videoId) {

          const videoIndex =
            pathParts.indexOf(videoId);

          if (
            videoIndex !== -1 &&
            pathParts[videoIndex + 1]
          ) {

            const possibleHash =
              pathParts[videoIndex + 1];

            /*
             * Don't treat another numeric segment
             * as the privacy hash.
             */
            if (!/^\d+$/.test(possibleHash)) {

              privacyHash = possibleHash;

            }

          }

        }


        /*
         * No video ID found
         */
        if (!videoId) {

          return null;

        }


        /*
         * Build Vimeo embed URL
         */
        let embedUrl =
          'https://player.vimeo.com/video/' +
          videoId;


        /*
         * Add privacy hash when available
         */
        if (privacyHash) {

          embedUrl +=
            '?h=' +
            encodeURIComponent(privacyHash) +
            '&autoplay=1';

        } else {

          embedUrl +=
            '?autoplay=1';

        }


        return embedUrl;

      } catch (error) {

        console.error('Vimeo URL error:', error);

        return null;

      }

    }


    /*
     * -----------------------------------------
     * OPEN VIDEO
     * -----------------------------------------
     */
    function openVideo(block) {

      const localVideo =
        block.dataset.localVideo || '';

      const externalVideo =
        block.dataset.videoUrl || '';


      /*
       * Clear previous video
       */
      modalContent.innerHTML = '';


      /*
       * ---------------------------------------
       * SHOPIFY LOCAL VIDEO
       * ---------------------------------------
       *
       * Local video takes priority.
       */
      if (localVideo) {

        const video =
          document.createElement('video');


        video.src = localVideo;

        video.controls = true;

        video.autoplay = true;

        video.playsInline = true;

        video.setAttribute(
          'playsinline',
          ''
        );

        video.setAttribute(
          'controls',
          ''
        );

        video.setAttribute(
          'autoplay',
          ''
        );


        modalContent.appendChild(video);

      }


      /*
       * ---------------------------------------
       * YOUTUBE / VIMEO
       * ---------------------------------------
       */
      else if (externalVideo) {

        let embedUrl = null;


        /*
         * Determine platform
         */
        if (
          externalVideo.includes('youtube.com') ||
          externalVideo.includes('youtu.be')
        ) {

          embedUrl =
            getYouTubeEmbed(
              externalVideo
            );

        }


        else if (
          externalVideo.includes('vimeo.com')
        ) {

          embedUrl =
            getVimeoEmbed(
              externalVideo
            );

        }


        /*
         * Create iframe
         */
        if (embedUrl) {

          const iframe =
            document.createElement('iframe');


          iframe.src = embedUrl;


          iframe.allow =
            'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media';


          iframe.allowFullscreen = true;


          iframe.setAttribute(
            'allowfullscreen',
            ''
          );


          iframe.setAttribute(
            'frameborder',
            '0'
          );


          iframe.referrerPolicy =
            'strict-origin-when-cross-origin';


          modalContent.appendChild(
            iframe
          );

        }

      }


      /*
       * ---------------------------------------
       * OPEN MODAL
       * ---------------------------------------
       */
      if (
        modalContent.children.length
      ) {

        modal.classList.add('active');

        document.body.style.overflow =
          'hidden';

      }

    }


    /*
     * -----------------------------------------
     * CLOSE VIDEO
     * -----------------------------------------
     */
    function closeVideo() {

      modal.classList.remove(
        'active'
      );


      /*
       * Removing the iframe/video stops
       * playback automatically.
       */
      modalContent.innerHTML = '';


      document.body.style.overflow =
        '';

    }


    /*
     * -----------------------------------------
     * VIDEO BLOCK CLICK
     * -----------------------------------------
     */
    const videoBlocks =
      section.querySelectorAll(
        '.fund-support-video'
      );


    videoBlocks.forEach(function (block) {

      block.addEventListener(
        'click',
        function () {

          openVideo(block);

        }
      );

    });


    /*
     * -----------------------------------------
     * CLOSE BUTTON
     * -----------------------------------------
     */
    if (closeButton) {

      closeButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          event.stopPropagation();

          closeVideo();

        }
      );

    }


    /*
     * -----------------------------------------
     * CLICK OUTSIDE VIDEO
     * -----------------------------------------
     */
    modal.addEventListener(
      'click',
      function (event) {

        if (
          event.target === modal
        ) {

          closeVideo();

        }

      }
    );


    /*
     * -----------------------------------------
     * ESC KEY
     * -----------------------------------------
     */
    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          modal.classList.contains('active')
        ) {

          closeVideo();

        }

      }
    );

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["previous-winners"] && !Shopify.designMode) return;
  try {
    
function initPreviousWinnersCarousels() {
  document
    .querySelectorAll('.previous-winners-videos-wrap[data-make-carousel="true"]')
    .forEach(function (carousel) {

      if (carousel.classList.contains('flickity-enabled')) {
        return;
      }

      new Flickity(carousel, {
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: false,
        prevNextButtons: true,
        draggable: true,
        adaptiveHeight: false,
        imagesLoaded: true
      });
    });
}

document.addEventListener('DOMContentLoaded', function () {
  initPreviousWinnersCarousels();
});

document.addEventListener('shopify:section:load', function () {
  initPreviousWinnersCarousels();
});

  } catch(e) { console.error(e); }
})();
})();
